export default "__VITE_ASSET__JLnvdiN5__"